import { BaseApiRepository } from "@/core/infrastructure/BaseApiRepository";
import { DashboardRepository } from "../domain/repositories/DashboardRepository";
import { ResponseDashboardGraphics, ResponseFutureFlowKV, ResponseInstruments, ResponseInstrumentTypes, ResponsePortfolios, ResponseSensitivityMeasures } from "../domain/entities/DashboardEntity";

export class DashboardApiRepository extends BaseApiRepository implements DashboardRepository {
  async getAllFutureFlows(): Promise<ResponseFutureFlowKV> {
    return await this.request<ResponseFutureFlowKV>("/api/futureFlow");
  }

  async getAllPortfolios(): Promise<ResponsePortfolios> {
    return await this.request<ResponsePortfolios>("/api/portfolios");
  }

  async getAllInstruments(): Promise<ResponseInstruments> {
    return await this.request<ResponseInstruments>("/api/instruments");
  }

  async getAllInstrumentTypes(): Promise<ResponseInstrumentTypes> {
    return await this.request<ResponseInstrumentTypes>("/api/instrumentTypes");
  }

  async getAllSensitivityMeasures(): Promise<ResponseSensitivityMeasures> {
    return await this.request<ResponseSensitivityMeasures>("/api/sensitivityMeasures");
  }

  async getAllDashboardGraphics(): Promise<ResponseDashboardGraphics> {
    return await this.request<ResponseDashboardGraphics>("/api/dashboardGraphics");
  }
}
